<div class="card-scoreboard_info font-small">
    @if (event.live) {
        <span class="live-badge">{{ sitecore.event.Live }}</span>
    }

    @if (event.stream && !showStream) {
        <vn-icon class="icon-badge-alignment" name="sports-video-badge-b" width="16" height="11" [class.video-badge-live]="event.live"></vn-icon>
    }
    <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
</div>
